export default function ({ isHMR, app, store, route, query, params, error, redirect }) {
  if (query.utm_source && params.utm_source !== '') {
    app.$cookies.set('locopack_utm_source', query.utm_source, {
      path: '/',
      maxAge: 60 * 60 * 24 * 1
    })
  }
}
